import { render, staticRenderFns } from "./CRMLawcaseComplain.vue?vue&type=template&id=7b873fce&scoped=true&"
import script from "./CRMLawcaseComplain.vue?vue&type=script&lang=js&"
export * from "./CRMLawcaseComplain.vue?vue&type=script&lang=js&"
import style0 from "./CRMLawcaseComplain.vue?vue&type=style&index=0&id=7b873fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b873fce",
  null
  
)

export default component.exports